import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import {useCompareParams} from '../CompareContent';
import {useUniversityFindQueryConfig} from '../../../../query/University/Query';
import {useCompareFacilitiesQueryConfig} from '../../../../query/Compare/Query';
import CompareFacilitiesContent from './CompareFacilitiesContent';

const CompareFacilities: FunctionComponent = () => {

    const [universityIds] = useCompareParams();

    const [universityFindConfig] = useUniversityFindQueryConfig(universityIds);
    const [compareFacilitiesConfig] = useCompareFacilitiesQueryConfig(universityIds);

    const universityFindQuery = useQuery(universityFindConfig);
    const compareFacilitiesQuery = useQuery(compareFacilitiesConfig);

    return (
        <Page className={'compare-page'}>
            {(universityFindQuery.data && compareFacilitiesQuery.data) &&
                <CompareFacilitiesContent
                    universities={universityFindQuery.data}
                    parts={compareFacilitiesQuery.data} />
            }
        </Page>
    );
};

export default CompareFacilities;
